export default [
    {
        path: '/questionarios-formularios/avaliacao/:id_avaliacao/questionario/:id_questionario/respondente/:id_pessoa',
        view: 'questionarios-formularios/Index',
        name: 'Formulário de Avaliação',
        permissions: ['RESPONDENTE'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Formulário de Avaliação',
                disabled: true,
                exact: true,
                to: '/questionarios-formularios/avaliacao/:id_avaliacao/questionario/:id_questionario/respondente/:id_pessoa',
            },
        ],
    }
];
